import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogAction,
} from '@/components/ui/alert-dialog';
import { Button } from './ui/button';
import { UnsavedChangesDialog } from '@client';
import { JointPolicyDeleteDialog } from './JointPolicyDeleteDialog';

type FundingSourceDeleteDialogsProps = {
  // Delete confirmation dialog
  showDeleteConfirmation: boolean;
  handleCancelDelete: () => void;
  handleConfirmDelete: () => void;

  // Delete blocked dialog
  showDeleteBlockedDialog: boolean;
  setShowDeleteBlockedDialog: (show: boolean) => void;
  deleteBlockedReason: string;

  // Edit blocked dialog
  showEditBlockedDialog: boolean;
  setShowEditBlockedDialog: (show: boolean) => void;
  editBlockedReason: string;

  // Joint policy delete dialog
  showJointPolicyDeleteDialog: boolean;
  handleJointPolicyDeleteCancel: () => void;
  handleJointPolicyDeleteConfirm: (mode: 'both' | 'client-only') => void;
  jointPolicyDeleteMode: 'both' | 'client-only';
  setJointPolicyDeleteMode: (mode: 'both' | 'client-only') => void;
  clientName: string | undefined;
  partnerName: string | undefined;
};

export function FundingSourceDeleteDialogs({
  showDeleteConfirmation,
  handleCancelDelete,
  handleConfirmDelete,
  showDeleteBlockedDialog,
  setShowDeleteBlockedDialog,
  deleteBlockedReason,
  showEditBlockedDialog,
  setShowEditBlockedDialog,
  editBlockedReason,
  showJointPolicyDeleteDialog,
  handleJointPolicyDeleteCancel,
  handleJointPolicyDeleteConfirm,
  jointPolicyDeleteMode,
  setJointPolicyDeleteMode,
  clientName,
  partnerName,
}: FundingSourceDeleteDialogsProps) {
  return (
    <>
      {/* Standard delete confirmation dialog */}
      <UnsavedChangesDialog
        showWarning={showDeleteConfirmation}
        handleCancelClose={handleCancelDelete}
        handleConfirmClose={handleConfirmDelete}
        primaryButtonText="Delete"
        secondaryButtonText="Cancel"
        dialogTitle="Delete Funding Option"
        dialogDescription="Are you sure you want to delete this funding option?"
        destructive={true}
      />

      {/* Delete blocked dialog */}
      <AlertDialog open={showDeleteBlockedDialog} onOpenChange={setShowDeleteBlockedDialog}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle className="text-primary-dark">
              Cannot Delete Funding Source
            </AlertDialogTitle>
            <AlertDialogDescription>
              {deleteBlockedReason}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogAction asChild>
              <Button onClick={() => setShowDeleteBlockedDialog(false)}>Close</Button>
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      {/* Edit blocked dialog */}
      <AlertDialog open={showEditBlockedDialog} onOpenChange={setShowEditBlockedDialog}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle className="text-primary-dark">
              Cannot Edit Funding Source
            </AlertDialogTitle>
            <AlertDialogDescription>
              {editBlockedReason}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogAction asChild>
              <Button onClick={() => setShowEditBlockedDialog(false)}>Close</Button>
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      {/* Joint policy delete dialog */}
      <JointPolicyDeleteDialog
        open={showJointPolicyDeleteDialog}
        onClose={handleJointPolicyDeleteCancel}
        onConfirm={handleJointPolicyDeleteConfirm}
        deleteMode={jointPolicyDeleteMode}
        onDeleteModeChange={setJointPolicyDeleteMode}
        clientName={clientName}
        partnerName={partnerName}
      />
    </>
  );
}
